import { AutocompleteOptions } from "@sinch/components/form/AutocompleteInput/types";
import { useQueryHandler } from "@sinch/hooks/useQueryHandler";
import { useMemo } from "react";

import { UserGroups } from "./queries.graphql";
import { UserGroupsQuery, UserGroupsQueryVariables } from "./queries.types";

/**
 * Loads the available user groups and exposes them as autocomplete options.
 * The query is only executed when `skip` is falsy, so callers can avoid
 * fetching groups when they are not needed.
 */
export const useUserGroups = ({ skip }: { skip?: boolean } = {}): { options: AutocompleteOptions[] } => {
  const { data } = useQueryHandler<UserGroupsQuery, UserGroupsQueryVariables>(UserGroups, undefined, { skip });

  const options = useMemo<AutocompleteOptions[]>(
    () => data?.userGroups?.map(({ id, label }) => ({ value: id, label })) ?? [],
    [data?.userGroups]
  );

  return { options };
};
